<template>
  <div>
    <el-table
      :data="riskList"
      style="width: 100%"
      height="calc(100vh - 360px)"
      @sort-change="handleSort"
    >
      <el-table-column prop="tenantUserId" label="用户UID" min-width="120" fixed="left" />
      <el-table-column prop="userNickName" label="用户昵称" min-width="140" fixed="left" />
      <el-table-column prop="userTypeName" label="用户类型" min-width="120" fixed="left" />
      <el-table-column prop="rebateRate" label="合约返佣比例" min-width="140" sortable="custom" />
      <el-table-column prop="level" label="层级" min-width="90" sortable="custom" />
      <el-table-column prop="inviteBy" label="邀请人UID" min-width="120" />
      <el-table-column prop="inviteByNickName" label="邀请人昵称" min-width="140" />
      <el-table-column prop="topTenantUserId" label="顶级合伙人UID" min-width="140" />
      <el-table-column prop="topNickName" label="顶级合伙人昵称" min-width="150" />
      <el-table-column prop="createTime" label="注册时间" min-width="160" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="fee" label="手续费" min-width="120" sortable="custom" />
      <el-table-column prop="realizedProfit" label="平仓盈亏" min-width="120" sortable="custom" />
      <el-table-column prop="realizedTotalProfit" label="总平仓盈亏" min-width="140" sortable="custom" />
      <el-table-column prop="winsCount" label="获利笔数" min-width="100" sortable="custom" />
      <el-table-column prop="openCount" label="开仓次数" min-width="100" sortable="custom" />
      <el-table-column prop="closeCount" label="平仓次数" min-width="100" sortable="custom" />
      <el-table-column prop="winRate" label="胜率" min-width="100" sortable="custom" />
      <el-table-column prop="winTotalRate" label="总胜率" min-width="100" sortable="custom" />
      <el-table-column prop="unsettledGains" label="总未实现盈亏" min-width="140" sortable="custom" />
      <el-table-column prop="feeDay" label="手续费已返" min-width="120" sortable="custom" />
      <el-table-column prop="sendCoin" label="增币" min-width="100" />
      <el-table-column prop="depositAmount" label="充值（折合 USDT）" min-width="130" sortable="custom" />
      <el-table-column prop="withdrawAmount" label="提现（折合 USDT）" min-width="130" sortable="custom" />
      <el-table-column prop="depositTotalAmount" label="总充值（折合 USDT）" min-width="150" sortable="custom" />
      <el-table-column prop="withdrawTotalAmount" label="总提现（折合 USDT）" min-width="150" sortable="custom" />
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import { mapState, mapMutations } from "vuex";

const SORT_MAP = {
  rebateRate: 1,
  level: 2,
  createTime: 3,
  fee: 4,
  realizedProfit: 5,
  realizedTotalProfit: 6,
  winsCount: 7,
  closeCount: 8,
  winRate: 9,
  winTotalRate: 10,
  unsettledGains: 11,
  depositAmount: 12,
  withdrawAmount: 13,
  depositTotalAmount: 14,
  withdrawTotalAmount: 15,
  feeDay: 16,
  openCount: 17,
};

export default {
  name: "UserRiskPanelList",
  components: {
    Pagination,
  },
  computed: {
    ...mapState("userRiskPanel", ["pagination", "list", "totalCount"]),
    riskList() {
      return this.list || [];
    },
  },
  methods: {
    ...mapMutations("userRiskPanel", ["setPagination"]),
    pageChanged(pagination) {
      this.setPagination(pagination);
      this.$emit("refresh", { ...pagination });
    },
    handleSort({ prop, order }) {
      if (!prop || !SORT_MAP[prop]) {
        this.$emit("refresh", { orderBy: "", desc: "", page: 1 });
        return;
      }
      if (!order) {
        this.$emit("refresh", { orderBy: "", desc: "", page: 1 });
        return;
      }
      const desc = order === "descending" ? 1 : 2;
      this.$emit("refresh", { orderBy: SORT_MAP[prop], desc, page: 1 });
    },
  },
};
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
